import { Button } from "@shared/ui";
import { Download } from "lucide-react";
import { ReactNode, RefObject } from "react";
import conceptStyles from "./concepts.module.scss";
import styles from "./editor.module.scss";

export function ScriptResultCard({
  cardRef,
  conceptsRef,
  showConcepts,
  saved,
  canDownload,
  canEdit,
  isDownloading,
  onDownload,
  children,
}: {
  cardRef?: RefObject<HTMLDivElement | null>;
  conceptsRef: RefObject<HTMLDivElement | null>;
  showConcepts: boolean;
  saved: boolean;
  canDownload: boolean;
  canEdit: boolean;
  isDownloading?: boolean;
  onDownload: () => void;
  children: ReactNode;
}) {
  return (
    <div ref={cardRef} className={styles.scriptCard}>
      <div className={styles.scriptCardHead}>
        <h3>Generated script</h3>
        <div className={conceptStyles.scriptActions}>
          {showConcepts ? (
            <Button
              size="small"
              onClick={() =>
                conceptsRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                })
              }
            >
              Change concepts
            </Button>
          ) : null}
          {saved ? <span className={conceptStyles.saved}>Saved</span> : null}
          <Button
            size="small"
            disabled={!canDownload || isDownloading}
            loading={isDownloading}
            onClick={onDownload}
          >
            <Download size={13} /> {isDownloading ? "Downloading…" : "Download PDF"}
          </Button>
        </div>
      </div>
      <p className={styles.scriptHint}>
        {canEdit
          ? "Type /ai to add or change the script without a selection. Select a passage and choose Revise with AI to rewrite only that part."
          : "The editor stays empty until you choose a concept."}
      </p>
      {children}
    </div>
  );
}
